import { render } from "./PopupComponent.vue?vue&type=template&id=be84f48e&scoped=true"
import script from "./PopupComponent.vue?vue&type=script&lang=js"
export * from "./PopupComponent.vue?vue&type=script&lang=js"

import "./PopupComponent.vue?vue&type=style&index=0&id=be84f48e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be84f48e"]])

export default __exports__